<template>
  <div>
    <v-btn color="primary"
           @click.stop="dialog = true"
    >
      <v-icon class="margin-right-small">mdi-plus-circle</v-icon>
      Add user group
    </v-btn>
    <v-dialog v-model="dialog"
              max-width="500"
              persistent
    >
      <AddUserGroupForm
        v-if="dialog"
        :connection="connection"
        @cancel="dialog = false"
        @ok="dialog = false"
        @groups-updated="$emit('groups-updated', $event)"
        @failure="$emit('failure', $event)"
      ></AddUserGroupForm>
    </v-dialog>
  </div>
</template>

<script>
import AddUserGroupForm from "./AddUserGroupForm";
import { HubConnection } from "@microsoft/signalr";

export default {
  name:       "AddUserGroup",
  components: { AddUserGroupForm },
  props:      {
    connection: HubConnection,
  },
  data: () => ({
    dialog: false,
  }),
};
</script>

<style scoped></style>
